<template>
  <div>
    <div v-if="form">
      <slot name="top"/>
      <div class="row">
        <div class="col-6">
          <q-btn v-if="id && (!readonly && !compare)" outline color="negative" label="delete record" @click="handleDeleteRecord" icon="delete"/>
        </div>
        <div class="col-6 text-right">
          <div class="q-subheading" v-if="id">
            <strong>ID:</strong>
            {{ id }}
          </div>
        </div>
      </div>
      <div class="block q-pa-sm"></div>
      <q-alert v-if="editingDisabled" type="warning" icon="warning" class="q-mb-md">This record has been deleted / archived. You may not make edits to this record until it has been restore.</q-alert>
      <div class="block full-width" v-for="sectionKey in Object.keys(sections)" :key="sectionKey" v-if="!show(sectionKey)">
        <div class="row justify-between">
          <div class="col-md-10">
            <h5 class="text-grey-6 uppercase no-margin q-headline q-pb-sm" :id="cleanId(sectionKey)">{{ sectionKey }}</h5>
          </div>
          <div class="col-md-2 text-right">
            <q-btn-dropdown v-if="Object.keys(sections).length > 1 && !isModal" label="Scroll To" color="primary" class="self-center no-shadow" size="sm">
              <q-list link>
                <q-item v-for="sectionKey in Object.keys(sections)" :key="sectionKey" @click.native="handleScroll(cleanId(sectionKey))">
                  <q-item-main>
                    <q-item-tile label>{{ sectionKey }}</q-item-tile>
                  </q-item-main>
                </q-item>
              </q-list>
            </q-btn-dropdown>
          </div>
        </div>
        <div class="mdi-card full-width q-pa-md">
          <!-- Loop components in section -->
          <div class="row">
            <div v-for="column in sections[sectionKey]" :key="column.field" :class="[!column.repeat && !column.relation && column.component.is !== 'q-editor' ? ['col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'] : 'col-12', showHide(column) ? 'hidden' : '']">
              <slot :name="`${column.field}__field`" :column="column" :model-id="id" :resource="resource" :value="form[column.field] || ''" :config="config" v-if="column.formDisplay !== false">
                <q-field
                  orientation="vertical"
                  :label="column.label"
                  :class="[showHide(column) ? 'invisible' : '', 'q-pa-md', requiredFields[column.name] ? 'is-required' : '']"
                  :icon-color="errors.has(column.name, validatorFormName) ? 'negative' : requiredFields[column.name] ? fieldColor : inputBgColor"
                  :helper="column.description"
                  :icon="column | fieldIcon(errors, validatorFormName)"
                  :error="errors.has(column.name, validatorFormName)"
                  :error-label="errors.first(column.name, validatorFormName)"
                  :warning="compareForms(form, column)"
                  inset="full"
                  :id="column.name"
                >
<!--                  :warning-label="compareForms(form, column, true)"-->
                  <!--<div v-if="compare && compareModel">
                    <div>NEW: {{ form | columnDefaultValue(column) }}</div>
                    <hr/>
                    <div>OLD: {{ compareModel | columnDefaultValue(column) }}</div>
                  </div>-->
<!--                  :compare-obj="compareModel | columnDefaultValue(column)"-->
                  <component
                    v-validate="column.component.validation"
                    :validator-form-name="validatorFormName"
                    :data-vv-scope="validatorFormName"
                    :data-vv-name="column.field"
                    class="no-shadow"
                    hide-underline
                    :color="column.component.props && column.component.props.color ? column.component.props.color : inputBgColor"
                    inverted-light
                    :is="column.component.is"
                    :value="form | columnDefaultValue(column)"
                    v-bind="column.component.props"
                    :model-id="id"
                    :parent-id="id ? id : savedId"
                    :column="column"
                    :resource="resource"
                    :disabled="column | disabledColumn"
                    :ref="`formCol_${column.name}`"
                    @add="handleAdd"
                    @remove="handleRemove(column.field, $event)"
                    @input="handleInput(column.field, $event)"
                    @change="handleInput(column.field, $event)"
                    @manual-update="updateFormField"
                    @async-init="handleAsyncInit"
                    @async-complete="handleAsyncComplete"
                    @sync="syncRelation(column)"
                  ></component>
                  <!--:compare="compare"
                  :compare-id="getCompareModelId(form, column)"-->
                  <!-- SHOW COMPARISON RECORD -->
                  <q-card v-if="compare && compareId && compareForms(form, column)" color="grey-1" text-color="black" class="q-mt-md">
                    <q-card-title>
                      <span slot="subtitle">Previous {{ column.label }}</span>
                    </q-card-title>
                    <q-card-separator />
                    <q-card-main>
                      <component
                        v-validate="column.component.validation"
                        :validator-form-name="validatorFormName"
                        :data-vv-scope="validatorFormName"
                        :data-vv-name="column.field"
                        class="no-shadow"
                        hide-underline
                        :color="column.component.props && column.component.props.color ? column.component.props.color : inputBgColor"
                        inverted-light
                        :is="column.component.is"
                        :value="compareModel | columnDefaultValue(column)"
                        v-bind="column.component.props"
                        :model-id="id"
                        :parent-id="id ? id : savedId"
                        :column="column"
                        :resource="resource"
                        :disabled="column | disabledColumn"
                        :ref="`formCol_${column.name}`"
                        :compare="compare"
                        :compare-id="getCompareModelId(form, column)"
                        :add-button="false"
                        :show-search="false"
                        :show-browse="false"
                        @add="handleAdd"
                        @remove="handleRemove(column.field, $event)"
                        @input="handleInput(column.field, $event)"
                        @change="handleInput(column.field, $event)"
                        @manual-update="updateFormField"
                        @async-init="handleAsyncInit"
                        @async-complete="handleAsyncComplete"
                        @sync="syncRelation(column)"
                      ></component>
                    </q-card-main>
                  </q-card>
                </q-field>
              </slot>
              <slot :name="`${column.field}__after`" :column="column" :model-id="id" :resource="resource" :value="form[column.field] || ''" :config="config"></slot>
            </div>
          </div>
        </div>
      </div>
      <div class="q-pa-md" v-if="invalidFields.length">
        <q-alert type="info" message="Form Invalid" :detail="`You have ${invalidFields.length} fields invalid`"></q-alert>
      </div>
      <slot name="bottom"/>
      <div v-if="editingDisabled">
        <q-alert v-if="editingDisabled" type="warning" icon="warning" class="q-mb-md">This record has been deleted / archived. You may not make edits to this record until it has been restore.</q-alert>
        <q-btn color="negative" @click="apiRestoreRecord" class="full-width" push size="lg" :disabled="false">Restore</q-btn>
      </div>
      <div v-else-if="!readonly && (compare || pendingApproval)">
        <!--<div class="row">
          <div class="col q-pr-sm"><q-btn color="primary" @click="handleApiSync(false)" class="full-width" push size="lg" :disabled="false">Save</q-btn></div>
          <div class="col q-pl-sm"><q-btn color="primary" @click="handleApiSync(false)" class="full-width" push size="lg" :disabled="false">Save and Approve</q-btn></div>
          <div class="col q-pl-sm"><q-btn color="secondary" @click="handleApiSync(false)" class="full-width" push size="lg" :disabled="false">Deny</q-btn></div>
        </div>-->
        <q-btn-dropdown color="primary" label="Actions" class="full-width" push size="lg">
          <q-list link>
            <q-item v-close-overlay @click.native="handleApiSync(false)">
              <q-item-side icon="save" inverted color="primary"/>
              <q-item-main>
                <q-item-tile label>Save</q-item-tile>
              </q-item-main>
            </q-item>
            <q-item v-close-overlay @click.native="handleApproveSave(true)">
              <q-item-side icon="check_box" inverted color="green"/>
              <q-item-main>
                <q-item-tile label>Save and Approve</q-item-tile>
              </q-item-main>
            </q-item>
            <!--<q-item v-close-overlay @click.native="handleDeny">
              <q-item-side icon="cancel" inverted color="secondary"/>
              <q-item-main>
                <q-item-tile label>Deny</q-item-tile>
              </q-item-main>
            </q-item>-->
          </q-list>
        </q-btn-dropdown>
      </div>
      <div v-else-if="!readonly && !compare">
        <div v-if="isModal && parentResourceColumn && parentResourceColumn.relation && parentResourceColumn.relation.requiresParentSave" class="row">
          <div class="col-sm-6 q-pr-md">
            <q-btn color="secondary" @click="handleApiSync(false)" class="full-width" push size="lg" :disabled="false">Save and Close</q-btn>
          </div>
          <div class="col-sm-6 a-pl-md">
            <q-btn color="primary" @click="handleApiSync(true)" class="full-width" push size="lg" :disabled="false">Save and Stay</q-btn>
          </div>
        </div>
        <div v-else>
          <q-btn color="primary" @click="handleApiSync(false)" class="full-width" push size="lg" :disabled="false">Save</q-btn>
        </div>
      </div>
      <slot name="goback" v-bind="listUrl" v-if="!compare && !pendingApproval">
        <q-btn flat v-go-back="listUrl" color="negative" full class="q-mt-lg">Cancel</q-btn>
      </slot>
    </div>
    <q-modal v-model="saveModalOpen" minimized no-esc-dismiss no-backdrop-dismiss>
      <q-modal-layout>
        <div class="modal-header">Save Complete</div>
        <div class="modal-body modal-message modal-scroll">
          <p>Your record has been successfully saved. What do you want to do next?</p>
        </div>
        <div class="modal-buttons row">
          <q-btn color="indigo-9" @click="goToAdd" label="Add New" class="no-shadow" outline/>
          <q-btn color="secondary" @click="goToEdit" label="Stay" class="no-shadow" outline/>
          <q-btn color="primary" @click="goToList" label="Return to List" class="no-shadow" outline/>
          <!--<q-btn color="black" @click="$router.go(-1)" label="Previous Page" class="no-shadow" outline/>-->
          <!-- <q-btn
            color="black"
            @click="$router.go(-1)"
            label="Previous Page"
            class="no-shadow"
            outline
          />-->
          <!-- <q-btn color="black" @click="form = {}" label="reset form" class="no-shadow" outline/>
          <q-btn
            color="black"
            @click="saveModalOpen = false"
            label="close"
            class="no-shadow"
            outline
          />-->
        </div>
      </q-modal-layout>
    </q-modal>
    <q-modal v-model="deleteModalOpen" minimized no-esc-dismiss no-backdrop-dismiss>
      <q-modal-layout>
        <div class="modal-header">Delete Complete</div>
        <div class="modal-body modal-message modal-scroll">
          <p>Your record has been successfully deleted. What do you want to do next?</p>
        </div>
        <div class="modal-buttons row">
          <q-btn color="indigo-9" @click="goToAdd" label="Add New" class="no-shadow" outline/>
          <q-btn v-if="isModal" color="secondary" @click="deleteModalOpen = false" label="Stay" class="no-shadow" outline/>
          <q-btn color="primary" @click="goToList" label="Return to List" class="no-shadow" outline/>
          <q-btn color="black" @click="$router.go(-1)" label="Previous Page" class="no-shadow" outline/>
          <!-- <q-btn color="black" @click="form = {}" label="reset form" class="no-shadow" outline/>
          <q-btn
            color="black"
            @click="saveModalOpen = false"
            label="close"
            class="no-shadow"
            outline
          />-->
        </div>
      </q-modal-layout>
    </q-modal>
    <q-inner-loading :visible="waitingForSave || !!asyncInProgress || !loaded"></q-inner-loading>
  </div>
</template>
<script>
  import {normalizePost} from '../../utils/normalize'
  import {normalizeDate} from '../../utils/dateHelpers'
  import {compareData, compareModelId} from '../../utils/compare'
  import {interactionDisplay, interactionSectionDisplay} from '../../utils/customBaseInteractions'
  import groupBy from '../../utils/arrayGrouper'
  import {extend, scroll} from 'quasar'
  import {mapGetters} from 'vuex'
  import colors from '../../mixins/colors'
  // const uuidv4 = require('uuid/v4')
  import uuidv4 from 'uuid/v4'

  const {getScrollTarget, setScrollPosition} = scroll

function sleep (fn, par, duration) {
  return new Promise(resolve => {
    setTimeout(() => resolve(fn(par)), duration)
  })
}

export default {
  inject: ['$validator'],
  mixins: [colors],
  name: 'BaseForm',
  props: {
    resource: {
      type: String,
      required: true
    },
    isModal: {
      type: Boolean,
      default: () => false
    },
    parentId: {
      type: Number,
      default: () => null
    },
    parentResource: {
      type: String,
      default: () => null
    },
    parentResourceColumn: {
      type: Object,
      default: () => null
    },
    skipResource: {
      type: String,
      default: () => null
    },
    id: {
      type: [String, Number]
    },
    config: {
      type: Object,
      default: () => {
      }
    },
    values: {
      type: Object,
      default: () => {
      }
    },
    callback: {
      type: Function
    },
    urls: {
      type: Object,
      default: () => {
      }
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    compare: {
      type: Boolean,
      default: () => false
    },
    compareId: {
      type: Number,
      default: () => 0
    },
    pendingApproval: {
      type: Boolean,
      default: () => false
    },
    queue: {
      type: Boolean,
      default: () => true
    },
    returnForm: {
      type: Boolean,
      default: () => false
    },
    noSave: {
      type: Boolean,
      default: () => false
    },
    providedModel: {
      type: [Object, Boolean],
      default: () => false
    }
  },
  data () {
    return {
      form: null,
      loaded: false,
      waitingForComponent: [],
      waitingForSave: false,
      savedId: null,
      dbModel: {},
      compareModel: {},
      saveModalOpen: false,
      deleteModalOpen: false,
      stay: false
    }
  },
  computed: {
    ...mapGetters('auth', ['hasAnyRole']),
    validatorFormName () {
      return `${this.resource}--BaseForm`
    },
    validatorReady () {
      return this.form !== null && this.loaded && !!this.asyncInProgress
    },
    getColumn () {
      return this.$store.getters[`${this.resource}/column`]
    },
    mode () {
      return this.savedId ? 'edit' : 'add'
    },
    invalidFields () {
      const validatorName = `$${this.validatorFormName}`
      return this.fields && this.fields[validatorName]
        ? Object.keys(this.fields[validatorName])
          .filter(key => this.fields[validatorName][key].invalid)
          .reduce((obj, key) => {
            const col = this.columns.find(col => col.name === key)
            if (col) {
              obj[key] = col
            }
            return obj
          }, {})
        : {}
    },
    sections () {
      return groupBy(this.columnComponents, 'section')
    },
    relations () {
      return this.$store.getters[`${this.resource}/relations`]
    },
    uniqueRelations () {
      return this.relations ? [...new Set(this.relations.map(column => column.relation.namespace))] : []
    },
    clientRoute () {
      return this.$store.state[this.resource].clientRoute
    },
    columns () {
      return this.$store.state[this.resource].columns || []
    },
    columnComponents () {
      // return this.columns.filter(col => col.component && col.field !== this.parentResource)
      return this.columns.filter(col => col.component && col.field !== this.skipResource)
    },
    requiredFields () {
      return this.columnComponents
        .filter(col => col.component && col.component.hasOwnProperty('validation'))
        .reduce((obj, col) => {
          obj[col.name] = !!col.component.validation.required
          return obj
        }, {})
    },
    listUrl () {
      if (this.urls && this.urls.listUrl) {
        return this.urls.listUrl
      }
      return `${this.clientRoute}/list`
    },
    editUrl () {
      return `${this.clientRoute}/edit/${this.savedId}`
    },
    addUrl () {
      return `${this.clientRoute}/add`
    },
    asyncInProgress () {
      return !!this.waitingForComponent.length
    },
    editingDisabled () {
      return !!this.form.removalDate
    },
    apiUrl () {
      return this.resource && this.$store.state[this.resource] ? this.$store.state[this.resource].apiEndpoint : ''
    }
  },
  methods: {
    showHide (column) {
      return interactionDisplay(column, this.form, this.resource)
    },
    show (sectionKey) {
      return interactionSectionDisplay(sectionKey, this.form, this.resource)
    },
    getCompareModelId (row, column) {
      return compareModelId(row, this.compareModel, column)
    },
    compareForms (row, column, value = false) {
      if (this.compare && this.compareModel) {
        return compareData(row, this.compareModel, column, value)
      } else {
      }
      if (value) {
        return ''
      }
      return false
    },
    preventMouseWheel () {
      console.log('preventMouseWheel')
    },
    // async apiUpdate({ commit, dispatch, state, getters }, { id, model, client, config = {}, fetchRelated = true, parentId = null, returnAll = false }) {
    async updateRelation (namespace, field, model, id) {
      // console.log('UPDATE >> ', 'namespace', namespace, 'field', field, 'model', model)
      try {
        return await this.$store.dispatch(`${namespace}/apiUpdate`, {
          client: this.$axios,
          noFilters: true,
          id: id,
          model: model
        })
      } catch (e) {
        // console.log(e)
      }
    },
    async saveRelation (namespace, field, model) {
      // console.log('SAVE >> ', 'namespace', namespace, 'field', field, 'model', model)
      try {
        return await this.$store.dispatch(`${namespace}/apiInsert`, {
          client: this.$axios,
          noFilters: true,
          model: model
        })
      } catch (e) {
        // console.log(e)
      }
    },
    async deleteRelation (namespace, field, model, id) {
      // console.log('DELETE >> ', 'namespace', namespace, 'field', field, 'model', model)
      try {
        return await this.$store.dispatch(`${namespace}/apiDelete`, {
          client: this.$axios,
          noFilters: true,
          id: id,
          model: model
        })
      } catch (e) {
        // console.log(e)
      }
    },
    async saveRelations () {
      // console.log('saveRelations')
      const relations = this.relations
      for (const relationColumn of relations) {
        // console.log(`> ${relationColumn.field} >> save relation...`)

        const {field, relation} = relationColumn
        const {type, namespace} = relation
        const localValue = this.form[field]
        const ignoreCompareArray = ['primaryPerson', 'billingPerson', 'safetyPerson', 'chasePerson', 'hrPerson', 'marketingPerson', 'counselPerson', 'businessDevPerson', 'estimatorPerson', 'estimator2Person', 'projectManagerPerson', 'projectManager2Person', 'laborPerson']
        if (this.compare && ignoreCompareArray.indexOf(field) >= 0) {
          return
        }
        // console.log('saveRelations field', field)
        // console.log('====== START saveRelations =======')
        // console.log('relationColumn', relationColumn) // comment
        // console.log('field', field) // comment
        // console.log('relation', relation) // looks correct
        // console.log('type', type) // many
        // console.log('namespace', namespace) // comment
        // console.log('localValue', localValue) // missing companyId and removalDate

        if (type === 'one' && typeof localValue === 'object' && localValue !== null) {
          // console.log('====== START SAVING SINGLE RELATIONS =======')
          const model = extend(true, {}, localValue)
          // console.log('localValue', localValue)

          // -- needs save
          if (!model.id) {
            // -- fill keys
            if (model.hasOwnProperty(this.resource)) {
              // console.log('delete model[this.resource]', model[this.resource])
              delete model[this.resource]
              model[`${this.resource}Id`] = this.savedId
            }

            const newModel = await this.saveRelation(namespace, field, model)
            this.$set(this.form, field, newModel)
          }

          if (!model && relationColumn && relationColumn.relation && relationColumn.relation.localKey) {
          }
          // if (model.id && model.hasOwnProperty(this.resource)) {
          //   console.log('test detach?')
          // }
          // TODO: We need to set companyId on each person -- namespace = person
          // console.log('this.resource', this.resource)
          // console.log('namespace', namespace)
          // console.log('this.apiUrl', this.apiUrl)
          // console.log('this.savedId', this.savedId)
          // console.log('localValue', localValue)
          if (this.resource && this.resource === 'company' && namespace && namespace === 'person' && this.apiUrl && this.savedId && localValue && localValue.id) {
            // if (this.resource && this.resource === 'company' && namespace && namespace === 'person' && this.apiUrl && this.savedId && localValue && localValue.companyId && localValue.id) {
            const apiUrl = this.$store.state[namespace] ? this.$store.state[namespace].apiEndpoint : false
            if (apiUrl) {
              let syncUrl = `${apiUrl}/${localValue.id}/sync`
              let formData = {companyId: this.savedId}
              this.$axios.post(syncUrl, formData)
              // console.log(`..done syncing person to company [${relationColumn.field}]`)
            }
          }

          // console.log(`..done saving [${relationColumn.field}]`)
        } else {
          if (type === 'many' && Array.isArray(localValue) && localValue.length) {
            // console.log('====== START SAVING MANY RELATIONS =======')
            const newFieldArray = []
            const relationValues = localValue.slice(0)
            // console.log('relationValues', relationValues) // same as local value

            for (const relationModel of relationValues) {
              // console.log('relationModel', relationModel)
              const model = extend(true, {}, relationModel)
              // console.log('model', model)
              // -- needs save
              if (!model.id && model.id !== 0 && namespace !== 'question') {
                /* ----- example --------------
                       *  model = eventDate
                       *  this.resource = event
                       *  eventDate.event = {}
                       *  becomes: eventDate.eventId = this.savedId
                       */

                if (model.hasOwnProperty(this.resource)) {
                  // console.log('delete model resource')
                  delete model[this.resource]
                  model[`${this.resource}Id`] = this.savedId
                }

                const newModel = await this.saveRelation(namespace, field, model)
                // console.log('newModel 1', newModel)
                newFieldArray.push(newModel)
              } else if (model.id === 0) {
                const newModel = await this.saveRelation(namespace, field, model)
                // console.log('newModel 2', newModel)
                newFieldArray.push(newModel)
              } else if (namespace === 'question') {
                // CUSTOM QUESTIONS for EVENTS - always save custom questions
                // console.log('========== SAVING QUESTION QUESTION MODEL ===========', model)
                if (model.hasOwnProperty(this.resource)) {
                  delete model[this.resource]
                  model[`${this.resource}Id`] = this.savedId
                }
                let questionModel = extend(false, model)
                let questionOptions = model.questionOption
                delete questionModel.questionOption
                let tempQuestionModel = questionModel
                if (!questionModel.delete && model.id) {
                  // console.log('updateRelation', questionModel)
                  tempQuestionModel = await this.updateRelation(namespace, field, questionModel, model.id)
                } else if (!questionModel.delete) {
                  // console.log('saveRelation', questionModel)
                  tempQuestionModel = await this.saveRelation(namespace, field, questionModel)
                }
                if (questionOptions && questionOptions.length > 0 && questionModel.questionType === 'select') {
                  // console.log('questionOptions 1', questionOptions)
                  for (let questionOption of questionOptions) {
                    questionOption.questionId = tempQuestionModel.id
                    if (questionOption.delete) {
                      questionOption = await this.deleteRelation('questionOption', 'questionOption', questionOption, questionOption.id)
                    } else if (questionOption.id) {
                      questionOption = await this.updateRelation('questionOption', 'questionOption', questionOption, questionOption.id)
                    } else {
                      questionOption = await this.saveRelation('questionOption', 'questionOption', questionOption)
                    }
                  }
                  // console.log('questionOptions 2', questionOptions)
                  tempQuestionModel.questionOptions = questionOptions
                }
                if (questionModel && questionModel.delete && questionModel.id) {
                  if (questionOptions.length > 0 && model.questionType === 'select') {
                    for (let questionOption of questionOptions) {
                      let deleteQuestion = await this.deleteRelation('questionOption', 'questionOption', questionOption, questionOption.id)
                      if (deleteQuestion) {
                        questionOption = {}
                      }
                    }
                  }
                  const {data} = await this.deleteRelation(namespace, field, model, questionModel.id)
                  if (data) {
                    tempQuestionModel = {}
                  }
                }
                // console.log('question tempQuestionModel', tempQuestionModel)
                newFieldArray.push(tempQuestionModel)
                // console.log('========== END OF SAVING QUESTION QUESTION MODEL ===========', model)
              } else {
                // console.log('oldModel', model)
                newFieldArray.push(model)
              }
              // console.log('newFieldArray', newFieldArray)
              // -- done with save
            }
            // -- end many relation loop
            // console.log('this.form', this.form, 'field', field, 'newFieldArray', newFieldArray)
            this.$set(this.form, field, newFieldArray)
            // console.log(`..done saving [${relationColumn.field}]`)
            // console.log('this.form', this.form)
            // if (this.parentResource !== null && this.parentResourceColumn !== null) {
            //   if (this.parentResourceColumn && this.parentResourceColumn.relation && this.parentResourceColumn.relation.saveBeforeAndAfter) {
            //     this.finalizeModal(postModel)
            //     console.log('saveBeforeAndAfter finalizeModal')
            //     return
            //   }
            // }
          }
        }
      }
    },
    async syncRelation (column) {
      // console.log('syncRelation')
      if (!this.savedId) {
        return
      }
      const apiUrl = this.apiUrl
      let syncUrl = `${apiUrl}/${this.savedId}/sync`
      const {field, relation} = column
      // console.log('syncRelation field', field)
      let foreignId = field
      let linkTable = false
      let relationData = []
      let temp = this.form[field]
      // // console.log('temp', temp)
      if (temp && relation && relation.namespace) {
        // console.log('relation', relation, 'relation.namespace', relation.namespace)
        // const relationValues = this.form[field]
        // const relationValues = extend(true, {}, this.form[field])
        // if (val.hasOwnProperty(col.field) && col.field !== 'id') {
        //   obj[col.field] = val[col.field]
        // }
        // -- handle one
        if (relation.type === 'one') {
          // console.log(' =========== one ===========', relation)
          const relationColumns = this.$store.getters[`${relation.namespace}/columns`]
          const relationValues = temp
          const baseRelationColumns = relationColumns.filter(col => !col.relation && col.field !== 'removalDate' && col.field !== 'dateApproved')
          // -----------------------------------------
          // // console.log('relation.type', relation.type)
          const _d = baseRelationColumns.reduce((obj, col) => {
            if (relationValues.hasOwnProperty(col.field)) {
              obj[col.field] = relationValues[col.field]
            }
            return obj
          }, {})
          relationData.push(_d)
          // console.log('_d', _d)
        } else if (relation && relation.linkTable) {
          // -- handle (many to many)
          // console.log(' =========== many to many relation ===========', relation)
          let model = relation.namespace
          if (relation.linkTableModel) {
            model = relation.linkTableModel
            linkTable = relation.linkTableModel
          } else if (column && column.field) {
            model = column.field
            linkTable = column.field
          }
          // console.log('model', model)
          // console.log('linkTable', linkTable)
          const relationColumns = this.$store.getters[`${model}/columns`]
          // const relationValues = temp
          const relationIds = temp.reduce((accumulator, currentValue, currentIndex) => {
            if (currentValue.id) {
              accumulator.push(currentValue.id)
            }
            return accumulator
          }, [])
          // console.log('relationIds', relationIds)
          // console.log('relation.namespace', relation.namespace)
          // console.log('relationColumns', relationColumns)
          // console.log('relationValues', relationValues)
          const linkTableColumn = relationColumns.filter(col => col.relation && col.relation.namespace === relation.namespace)
          if (linkTableColumn && linkTableColumn[0] && linkTableColumn[0].relation && linkTableColumn[0].relation.fk) {
            foreignId = linkTableColumn[0].relation.fk
          }
          // console.log('linkTableColumn', linkTableColumn)
          // -----------------------------------------
          // console.log('relation.type', relation.type)
          relationData = relationIds
        } else {
          // console.log(' =========== else sync many w/out linktable ===========', relation)
          if (relation && relation.namespace === 'question') {
            // console.log('temp', temp)
            // console.log('relationData', relationData)
            if (temp && temp.questionOption && temp.questionOption > 0) {
              // console.log('sync questionOption', temp.questionOption)
            }
            return false
          }
          // -- handle array
          const relationColumns = this.$store.getters[`${relation.namespace}/columns`]
          const baseRelationColumns = relationColumns.filter(col => !col.relation && col.field !== 'removalDate' && col.field !== 'dateApproved')
          const relationValues = temp
          // // console.log('relationColumns', relationColumns)
          // // console.log('baseRelationColumns', baseRelationColumns)
          // // console.log('relationValues', relationValues)
          for (const val of relationValues) {
            const _d = baseRelationColumns.reduce((obj, col) => {
              if (val.hasOwnProperty(col.field)) {
                obj[col.field] = val[col.field]
              }
              if (obj && !obj.id) {
                obj.id = 0
              }
              // if (obj && obj.id) {
              //   delete obj.id
              // }
              // // console.log('sync obj', obj)
              return obj
            }, {})
            if (_d) {
              relationData.push(_d)
            }
          }
        }
        if (linkTable) {
          // Add linktable to URL
          if (relationData && relationData.length && relationData[0] > 0) {
            syncUrl = `${syncUrl}?linkTable=${linkTable}`
          } else {
            syncUrl = `${syncUrl}?linkTable=${linkTable}&forceDelete=true`
          }
        }
        // console.log('relationData', relationData)
        // if (relationData && relationData.length && relationData[0] > 0) {
        const formData = {
          // [field]: relationData
          [foreignId]: relationData
        }
        // console.log('formData', formData)
        // return this.$axios.post(syncUrl, formData)
        // console.log('syncRelation this.form last', this.form)
        if (linkTable) {
          return this.$axios.post(syncUrl, formData)
        } else {
          return this.$axios.patch(syncUrl, formData)
        }
        // }
      }
      return false
    },
    async handleDeleteRecord () {
      const message = this.editingDisabled ? 'Are you SURE you want to force delete this record forever? This will permanently destroy this record and all associated data. Please be sure!' : 'Are you sure you want to delete this record?'
      const action = this.editingDisabled ? 'apiForceDelete' : 'apiDelete'
      try {
        await this.$q.dialog({
          title: 'Confirm Delete',
          message,
          ok: 'Delete',
          cancel: 'Cancel'
        })
        try {
          await this.$store.dispatch(`${this.resource}/${action}`, {
            id: this.id,
            client: this.$axios
          })
          this.$q.notify({
            type: 'positive',
            message: 'Record deleted successfully',
            icon: 'delete forever'
          })
          this.deleteModalOpen = true
          // if (this.listUrl) {
          //   this.$router.replace({ path: this.listUrl })
          // } else {
          //   this.$router.go(-1)
          // }
        } catch (e) {
          this.$q.notify({
            type: 'negative',
            message: 'Record could not be deleted',
            icon: 'delete forever'
          })
        }
      } catch (e) {
        //
      }
    },
    /* LOAD */
    async fetchData (queue) {
      queue = typeof queue !== 'undefined' ? queue : this.queue
      this.loaded = true
      // console.log('BASE FORM fetchData...')
      if (this.savedId) {
        const model = await this.$store.dispatch(`${this.resource}/fetchOne`, {client: this.$axios, id: this.savedId, noFilters: true, queue: queue})
        // console.log('fetchData model', model)
        // console.log('savedId', model)
        // this.$set(this, 'dbModel', model)
        // this.$set(this, 'form', model)
        this.form = extend(true, {}, model)
        this.dbModel = extend(true, {}, model)
      } else if (this.providedModel) {
        this.form = extend(true, {}, this.providedModel)
        this.dbModel = extend(true, {}, this.providedModel)
        // console.log('providedModel', this.providedModel)
      } else {
        const storeModel = this.$store.getters[`${this.resource}/model`]
        // console.log('storeModel', storeModel)
        if (storeModel) {
          // console.log('this.savedId', this.savedId)
          // console.log('fetchData storeModel', storeModel)
          // this.$set(this, 'dbModel', storeModel)
          // this.$set(this, 'form', storeModel)
          this.form = extend(true, {}, storeModel)
          this.dbModel = extend(true, {}, storeModel)
        }
      }
      this.$nextTick(() => {
        this.loaded = true
      })
      // this.loaded = true
    },
    async loadCompareModel () {
      // console.log('loadCompareModel', this.compare, this.compareId)
      // if (this.compare && (this.compareId || (this.compareObj && this.compareObj.id))) {
      if (this.compare && this.compareId) {
        // console.log('fetchOne compareId', this.compareId)
        const compareModel = await this.$store.dispatch(`${this.resource}/fetchOne`, {client: this.$axios, id: this.compareId, noFilters: true, queue: null})
        // console.log('compareModel', compareModel)
        this.compareModel = extend(true, {}, compareModel)
        // console.log('this.compareModel', this.compareModel)
      }
    },
    /* GENERAL */
    cleanId (string) {
      return string.replace(/\W/g, '_')
    },
    handleScroll (el) {
      const ele = document.getElementById(el) // You need to get your element here
      const target = getScrollTarget(ele)
      const offset = ele.offsetTop - ele.scrollHeight
      const duration = 300
      setScrollPosition(target, offset, duration)
    },
    handleAsyncInit (col = {}) {
      // console.log('...waiting for component: ', col.field)
      if (!col.field) {
        return
      }
      const index = this.waitingForComponent.indexOf(col.field)
      if (index === -1) {
        this.waitingForComponent.push(col.field)
      }
    },
    handleAsyncComplete (col = {}) {
      // console.log('component done: ', col.field)
      if (!col.field) {
        return
      }
      const index = this.waitingForComponent.indexOf(col.field)
      if (index !== -1) {
        this.waitingForComponent.splice(index, 1)
      }
    },
    handleAdd (field, obj) {
      // console.log('>> ADD', field, obj)
      this.form[field].push(obj)
    },
    handleRemove (column, event) {
      // console.log(`>> handleRemove: column > `)
      // console.log(column)
      // console.log(`>> handleRemove: event > `)
      // console.log(event)
      const {field, index} = event
      // // console.log(`>> handleRemove: ${field} = ${index}`)
      if (index !== undefined && index >= 0) {
        try {
          this.$delete(this.form[column], index)
        } catch (e) {
          try {
            this.$delete(this.form, index)
          } catch (e) {
            // console.log(`Failed slice for field ${field}`)
            try {
              this.$set(this.form, field, null)
            } catch (e) {
              // console.log(`Failed set form field to null for field ${field}`)
            }
          }
        }
      }
    },
    triggerInput (field, data) {
      // this.$set(this.form, field, data)
      const ref = this.$refs[`formCol_${field}`]
      if (ref !== undefined) {
        try {
          // console.log('emit change', data)
          ref[0].$emit('change', data)
          // ref[0].$emit('focus')
        } catch (e) {
          // console.log('cannot emit input', field)
        }
        // ref.$emit('input', data)-
        // ref.$emit('focus')
      }
    },
    updateFormField (field, data) {
      // console.log('manual-update', field, data)
      this.$set(this.form, field, data)
    },
    handleInput (field, data) {
      // // console.log('handleInput', 'field', field, 'data', data)
      const column = typeof field === 'object' && field.field ? field : this.columnComponents.find(c => c.field === field)
      if (column && column.relation) {
        const {localKey, type} = column.relation
        // -- MANY
        if (type && type === 'many') {
          if (data && Array.isArray(data) && field.name) {
            this.$set(this.form, field.name, data)
            return
          }
        }
        if (localKey) {
          const formHasLocalKey = this.form.hasOwnProperty(localKey)
          const newId = typeof data === 'object' && data.id ? data.id : typeof data === 'object' && data.value ? data.value : typeof data === 'number' ? data : data
          if (formHasLocalKey) {
            this.$set(this.form, localKey, newId)
          }
        }
      }
      this.$set(this.form, field, data)
      if (this.fields[`$${this.validatorFormName}`][field]) {
        this.$validator.validate(`${this.validatorFormName}.${field}`)
      }
    },
    async syncModelRelations () {
      const relations = this.relations.filter(column => column.relation.type === 'many')
      for (const relationColumn of relations) {
        await this.syncRelation(relationColumn)
      }
    },
    async handleApproveSave (stay = false) {
      await this.handleApiSync(stay)
      this.$parent.$emit('approve', this.form, this.resource, this.pendingApproval)
    },
    async handleDeny () {
      this.$parent.$emit('deny', this.form, this.resource, this.pendingApproval)
    },
    async handleApiSync (stay = false) {
      // console.log('validate this.form', this.form)
      this.$set(this, 'stay', stay)
      if (this.errors) {
        console.log('errors', this.errors)
      }
      const result = await this.$validator.validate(`${this.validatorFormName}.*`)
      // console.log('Validation Result', result)
      if (!result) {
        this.$q.notify({
          message: 'Please complete all required fields',
          type: 'negative'
        })
        return
      }
      if (!this.noSave) {
        if (this.savedId) {
          await this.apiUpdate()
        } else {
          await this.apiInsert()
        }
      } else if (this.returnForm) {
        if (this.isModal) {
          this.finalizeModal(this.form)
        } else {
          this.finalizeSave(this.form)
        }
        // this.$emit('returnForm', this.form)
      }
    },
    isWaitingForUploads () {
      return !!this.asyncInProgress
    },
    async apiRestoreRecord () {
      try {
        this.waitingForSave = true
        // const postModel = normalizePost(extend(true, {}, this.form), this.columns)
        await this.$store.dispatch(`${this.resource}/apiRestore`, {client: this.$axios, id: [this.id]})
        // console.log('status', data.status)
        // if (data) {
        this.form.deletedAt = null
        // console.log('Restored: ', data)
        this.form.removalDate = null
        this.waitingForSave = false
        this.waitingForComponent = []
        if (this.callback !== undefined) {
          this.callback()
        } else {
          this.$q.notify({
            message: 'Record has been restored',
            type: 'positive'
          })
        }
        // }
      } catch (e) {
        this.waitingForSave = false
        this.waitingForComponent = []
        // console.log(e.message)
      }
    },
    async apiInsert () {
      this.waitingForSave = true
      console.log(' =========== apiInsert =========== ')
      try {
        // console.log('this.form', this.form)
        // console.log('extend', extend(true, {}, this.form))
        // console.log('this.columns', this.columns)
        if ('guidId' in this.form) {
          this.form.guidId = uuidv4()
        }
        if (this.resource === 'company' || this.resource === 'person') {
          const now = normalizeDate(null, 'mysql')
          this.form.updatedAt = now
          this.form.createdAt = now
        }
        // console.log('this.form before', this.form)
        // console.log('this.columns', this.columns)
        const postModel = await normalizePost(extend(true, {}, this.form), this.columns, null, 'new', this.parentId, this.parentResource)
        // console.log('postModel Insert', postModel)
        // console.log('this.resource', this.resource)
        if (this.parentResource !== null && this.parentResourceColumn !== null) {
          if (this.parentResourceColumn && this.parentResourceColumn.relation && this.parentResourceColumn.relation.parentRestraint) {
            this.finalizeModal(postModel)
            // console.log('finalizeModal')
            return
          }
        }
        // console.log('postModel', postModel)
        // console.log('dispatch apiInsert')
        const data = await this.$store.dispatch(`${this.resource}/apiInsert`, {client: this.$axios, model: postModel})
        if (data) {
          // console.log('apiInsert returned data')
          if (data && data.id) {
            // console.log('lets do afterSaveHooks')
            // await this.fetchData(false)
            return this.afterSaveHooks(data.id, data)
            // return this.afterSaveHooks(data.id, this.form)
          }
        }
      } catch (e) {
        this.waitingForSave = false
        this.waitingForComponent = []
        this.$q.notify({
          duration: 10000,
          type: 'negative',
          message: 'There was an error saving your data'
        })
      }
    },
    async apiUpdate () {
      console.log(' =========== apiUpdate =========== ')
      this.waitingForSave = true
      // let formData = this.form
      // if (formData.id) {
      //   delete formData.id
      // }
      // console.log('this.form before', this.form)
      if (this.resource === 'company' || this.resource === 'person') {
        this.form.updatedAt = normalizeDate(null, 'mysql')
        // console.log('this.form', this.form)
      }
      let postModel = await normalizePost(extend(true, {}, this.form), this.columns, this.savedId, 'update')
      if ('id' in postModel) {
        delete postModel.id
      }
      // console.log('postModel Update', postModel)
      try {
        const data = await this.$store.dispatch(`${this.resource}/apiUpdate`, {
          client: this.$axios,
          model: extend(true, {}, postModel, {isDirty: true}),
          id: this.savedId
        })
        if (data && data.id) {
          // await this.fetchData(false)
          return this.afterSaveHooks(data.id, data)
          // return this.afterSaveHooks(data.id, this.form)
        }
      } catch (e) {
        // console.log(e)
        this.waitingForSave = false
      }
      // console.log('this.form after', this.form)
    },
    async afterSaveHooks (id, model) {
      console.log(' =========== afterSaveHooks =========== ')
      this.$set(this, 'savedId', parseInt(id))
      let payload = {id, model, resource: this.resource}
      this.$root.$emit('trigger_upload', {payload})
      // this.$root.$emit('model_saved', { id, model })
      // this.$emit('formSaved', { id, model })
      // console.log('formSaved', model)
      // console.log('this.form 1', this.form)
      await this.saveRelations()
      // console.log('this.form 2', this.form)
      await this.syncModelRelations()
      // console.log('this.form 3', this.form)
      await sleep(this.isWaitingForUploads, null, 900)
      this.$set(this, 'waitingForSave', false)
      this.$set(this, 'waitingForComponent', [])
      await this.fetchData(false) // updates this.form (queue) in case its opened again, it will have the correct info as post returns do not have includes
      // let payload = {id, model: this.form, resource: this.resource}
      // this.$root.$emit('trigger_upload', { payload })
      this.$root.$emit('model_saved', {id, model: this.form})
      this.$emit('formSaved', {id, model: this.form})
      // -- hand off callback
      if (this.callback !== undefined && typeof this.callback === 'function') {
        // console.log('Callback', this.callback)
        // This hits components such as RelationFieldMany & RelationFieldOne and those methods are found in relationFields.js
        this.callback(this.form, id, this.stay)
        // console.log('this.form 4', this.form)
        // console.log('callback model', model)
        return
      }
      if (this.isModal) {
        this.$set(this, 'waitingForSave', false)
        this.$set(this, 'waitingForComponent', [])
        // this.finalizeModal(model)
        this.finalizeModal(this.form)
        return
      }

      // this.finalizeSave(model)
      this.finalizeSave(this.form)
    },
    finalizeModal (model) {
      // console.log('==== finalizeModal ====')
      // this.fetchData()
      if (this.returnForm) {
        this.$emit('add', this.form, null, this.stay)
      } else {
        this.$emit('add', model, null, this.stay)
        // this.$emit('add', this.form)
      }
    },
    async finalizeSave (model) {
      // console.log('==== finalizeSave ====')
      // this.fetchData()
      if (this.returnForm) {
        this.$emit('add', this.form)
      } else {
        this.$emit('add', model)
        // this.$emit('add', this.form)
      }
      this.$q.notify({
        message: 'Saving complete!',
        type: 'positive'
      })
      this.saveModalOpen = true
      // console.log('this.form 6', this.form)
      // this.form = {}
      // try {
      //   // const answer = await this.$q.dialog({
      //   await this.$q
      //     .dialog({
      //       title: 'Save Complete',
      //       message: `Your record has been successfully saved. What do you want to do next?`,
      //       // options: {
      //       //   type: 'radio',
      //       //   model: 'action',
      //       //   items: [
      //       //     {label: 'Add New', value: 'actionAdd', color: 'primary'},
      //       //     {label: 'Back to List', value: 'actionList', color: 'primary'},
      //       //     {label: 'Edit This Record', value: 'actionEdit', color: 'primary'}
      //       //   ]
      //       // },
      //       ok: {
      //         label: 'Return to List',
      //         outline: true,
      //         color: 'primary'
      //       },
      //       cancel: {
      //         label: 'Stay',
      //         outline: true,
      //         color: 'secondary'
      //       }
      //       // cancel: true
      //     })
      //     .then(() => {
      //       this.$router.push({ path: this.listUrl })
      //     })
      //     .catch(() => {
      //       // this.$q.notify('Disagreed...')
      //     })
      // switch (answer) {
      //   case 'actionAdd':
      //     const reAdd = new RegExp('/add', 'i')
      //     if (reAdd.test(this.$route.path)) {
      //       // -- on add form, so lets clear!
      //       this.savedId = null
      //       this.fetchData()
      //       return
      //     }
      //     this.$router.push({path: this.addUrl})
      //     return
      //   case 'actionList':
      //     this.$router.push({path: this.listUrl})
      //     return
      //   case 'actionEdit':
      //     const reEdit = new RegExp('/edit', 'i')
      //     if (reEdit.test(this.$route.path)) {
      //       // -- on edit form, so lets do nothing!
      //       return
      //     }
      //     this.$router.push({path: this.editUrl})
      // }
      // } catch (e) {}
    },
    goToAdd () {
      // this.form = {}
      const reAdd = new RegExp('/add', 'i')
      if (reAdd.test(this.$route.path)) {
        // -- on add form, so lets clear!
        this.savedId = null
        this.fetchData()
        // this.saveModalOpen = false
        location.reload()
        return
      }
      this.$router.push({path: this.addUrl})
    },
    goToList () {
      // this.form = {}
      this.$router.push({path: this.listUrl})
    },
    goToEdit () {
      // this.form = {}
      const reEdit = new RegExp('/edit', 'i')
      if (reEdit.test(this.$route.path)) {
        // -- on edit form, so lets do nothing!
        // return
        this.saveModalOpen = false
        location.reload()
      }
      this.$router.push({path: this.editUrl})
    }
  },
  beforeDestroy () {
    this.$root.$off('update-form', this.handleInput)
  },
  mounted () {
    this.$root.$on('update-form', this.handleInput)
    // Prevent mousewheel on numbers
    document.addEventListener('mousewheel', function (event) {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur()
      }
    })
  },
  async created () {
    this.form = {}
    // console.log('this.form', this.form)
    if (this.id) {
      this.savedId = parseInt(this.id)
    }
    await this.fetchData()
    // await this.loadCompareModel()
  },
  watch: {
    validatorReady: {
      handler (v) {
        if (v) {
          const nameColumn = this.getColumn('name')
          if (nameColumn) {
            const field = this.$validator.fields.find({name: 'name', scope: this.validatorFormName})
            if (field === undefined) {
              this.$validator.attach({
                scope: this.validatorFormName,
                name: 'name',
                rules: nameColumn.component ? nameColumn.component.validation : {}
              })
            }
          }
        }
      }
    },
    compare: {
      handler (v) {
        if (v) {
          this.loadCompareModel()
        }
      }
    }
  }
}
</script>
